export const FLAG_GETTING_BUS_FUEL_GROUPS = 'FLAG_GETTING_BUS_FUEL_GROUPS';
export const GET_BUS_FUEL_GROUPS = 'GET_BUS_FUEL_GROUPS';
export const CLEAR_BUS_FUEL_GROUPS = 'CLEAR_BUS_FUEL_GROUPS';
export const FLAG_BUS_FUEL_GROUP_ACTIVITY = 'FLAG_BUS_FUEL_GROUP_ACTIVITY';
export const GET_BUS_FUEL_GROUP = 'GET_BUS_FUEL_GROUP';
export const CLEAR_BUS_FUEL_GROUP = 'CLEAR_BUS_FUEL_GROUP';
export const POST_BUS_FUEL_GROUP = 'POST_BUS_FUEL_GROUP';
export const PUT_BUS_FUEL_GROUP = 'PUT_BUS_FUEL_GROUP';
